import React, { useState } from 'react';
import { useTravelerStyles } from '../../../common/traveler/TravelerStyles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography ,Link as MuiLink } from '@material-ui/core';
import { ConvertFile } from '../reportSequenceDefinitions/ConvertFile';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import { toast } from 'react-toastify';
import { formatDateDate } from '../../../common/formatDate';

export const ReportTravelerComponent = ({ data }: any) => {
    const classes = useTravelerStyles();

    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = (e: any) => {
        e.preventDefault();
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleDownload = (fileUrl: string) => {
        if(fileUrl){
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }else{
        console.error("Download URL not found");
    }
    };

    return (
        <>
            <Grid item xs={2} className={classes.baseBorder} style={{ backgroundColor: "yellow" }}>
                <Typography variant="body2" align="center" style={{ fontWeight: "bold" }}>
                    {data.report_type_definition_id}
                </Typography>
            </Grid>
            <Grid
                item
                xs={10}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
            >
                <Typography
                    variant="body2"
                    align="center"
                    style={{ fontWeight: "bold" }}
                >
                    {data.report_sequence_definition_name}
                </Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>
                <Typography variant="body2" align="center">{data.report_type_definition_name ? data.report_type_definition_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.due_date ?formatDateDate(data.due_date)  : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.report_writer ? data.report_writer : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={2} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.report_approver ? data.report_approver : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.issue_date ? formatDateDate(data.issue_date) : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.data_ready_status!='Define' ? data.data_ready_status : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.baseBorder}>

                <Typography variant="body2" align="center">{data.status_disposition_name ? data.status_disposition_name : 'N/A'}</Typography>
            </Grid>
            <Grid item xs={1} className={classes.baseBorder}>

                <Typography variant="body2" align="center">
                    <MuiLink href="#" onClick={handleOpenDialog} > View <br/> Documents

                    </MuiLink>
                </Typography>
            </Grid>
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>Report Template</DialogTitle>
                <DialogContent>
                    <ConvertFile Data={data} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Grid item xs={1} className={classes.baseBorder}>
                <Typography variant="body2" align="center">
                    <IconButton onClick={() => handleDownload(data.reportexecution_azurefile)}>
                        <FileDownloadIcon />
                    </IconButton>
                </Typography>
            </Grid>








        </>
    );
};